/*eslint new-cap:0 */
import ko from 'knockout';
import _ from 'underscore';
import URI from 'urijs';
import { evaluateAdCustomizers as newEvaluateAdCustomizers } from '@bingads-webui-campaign/ad-customizers';
import { evaluateAdCustomizers as legacyEvaluateAdCustomizers } from '@bingads-webui-campaign-legacy/crud-ad/service/adCustomizersUtils';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import config from '@bingads-webui-component-legacy/config/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import jsDataCampaign from '@bingads-webui-component-legacy/js-data-campaign/index';
import { i18nDummy } from '@bingads-webui-campaign-legacy/crud-ad/service/utils/i18n-dummy-vnext';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
const i18nAdCustomizers = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/ad-customizers');

const permissions = config.get('Permissions') || {};

const {
  IsNewAdsAdCustomizerEditorEnabled,
  IsIfFunctionMilestone1Enabled,
} = permissions;

const withNewAdCustomizerEditor = IsNewAdsAdCustomizerEditorEnabled ||
  IsIfFunctionMilestone1Enabled;

const evaluateAdCustomizers = (text) => {
  if (withNewAdCustomizerEditor) {
    return newEvaluateAdCustomizers({
      text,
      deps: {
        config,
        i18n: i18nAdCustomizers,
        countdownI18nDummy: i18nDummy,
        instrumentation,
        jsDataCampaign,
        edmCampaign,
      },
      adType: 'DynamicSearchAd',
    });
  }
  return legacyEvaluateAdCustomizers(text);
};

const combineText = (textPart1, textPart2) => {
  if (!textPart1 && !textPart2) {
    return '';
  } else if (_.isEmpty(textPart2)) {
    return textPart1;
  } else if (_.isEmpty(textPart1)) {
    return textPart2;
  }

  // If text1 does not end with any of separators [. ? !], use a period and space between text1 and text2 while stitching.
  // If text1 ends with one of those separators, use only a space.
  if ('.?!'.indexOf(textPart1.slice(-1)) > -1) {
    return `${textPart1} ${textPart2}`;
  } else {
    return `${textPart1}. ${textPart2}`;
  }
};

export default class {
  constructor(adViewModel, placeholders) {
    // this.Text = ko.computed(() => {
    //   return adViewModel.Text() || placeholders.Text;
    // });
    const self = this;
    const fields = ['Text', 'TextPart2'];

    _.each(fields, (fieldName) => {
      self.createField(`Parsed${fieldName}`, adViewModel[fieldName]);
    });

    this.Text = ko.computed(() => {
      const textPart1 = self.ParsedText();

      // All space is not allowed
      const textPart2 = self.ParsedTextPart2() !== null && self.ParsedTextPart2().trim() === '' ? '' : self.ParsedTextPart2();

      if (_.isEmpty(textPart1) && _.isEmpty(textPart2)) {
        return placeholders.Text;
      }
      return combineText(textPart1, textPart2);
    });

    this.Title = ko.observable(`{${i18n.get('Ad_DSA_Title')}}`);

    let combinedUrl = ko.computed(() => {
      let result = adViewModel.domain();

      let addPath = (path) => {
        if (!_.isEmpty(path)) {
          result += `/${path}`;
        }
      };

      addPath(adViewModel.Path1());
      addPath(adViewModel.Path2());

      return result;
    });

    this.DisplayUrl = combinedUrl;
    this.DestinationUrl = ko.computed(() => {
      let protocol = adViewModel.protocol();
      let uri = new URI(combinedUrl());

      return uri.protocol(protocol).toString();
    });
    this.DisclaimerLineText = ko.computed(() => {
      return adViewModel.disclaimerInfo().LineText || '';
    });

    this.ShowDisclaimer =  ko.computed(() => {
      return true;
    });

    this.IsDisclaimerPopupHintVisible = ko.observable(false);

    this.DisclaimerFinalUrl =  ko.computed(() => {
      if (self.ShowDisclaimer() && _.size(adViewModel.disclaimerInfo().FinalUrls)) {
        return adViewModel.disclaimerInfo().FinalUrls[0];
      }

      return '';
    });

    this.IsAdditionalLineLayout =  ko.computed(() => {
      if (self.ShowDisclaimer() && adViewModel.disclaimerInfo().DisclaimerLayout === 'AdditionalLine') {
        return true;
      }

      return false;
    });

    this.IsPopupLayout =  ko.computed(() => {
      if (self.ShowDisclaimer() && adViewModel.disclaimerInfo().DisclaimerLayout === 'Popup') {
        return true;
      }

      return false;
    });

    this.DisclaimerPopHint = ko.computed(() => {
      if (self.ShowDisclaimer() && adViewModel.disclaimerInfo().DisclaimerLayout === 'Popup') {
        return adViewModel.disclaimerInfo().Title;
      }

      return '';
    });

    this.DisclaimerPopupText =  ko.computed(() => {
      if (self.ShowDisclaimer() && adViewModel.disclaimerInfo().DisclaimerLayout === 'Popup') {
        return adViewModel.disclaimerInfo().PopupText;
      }

      return '';
    });

  }

  /**
   * Adds a property to this that holds parsed value of passed dependency
   * @param {string} fieldName - new property's name
   * @param {Object} dependency - observable that contains the raw value to be parsed for preview
   * @returns {undefined}
   */
  createField(fieldName, dependency) {
    const self = this;

    this[fieldName] = ko.observable('');
    evaluateAdCustomizers(dependency()).then((value) => {
      self[fieldName](value);
    });

    // We cannot directly use computedObservables because evaluateAdCustomizers is async
    dependency.subscribe(() => {
      evaluateAdCustomizers(dependency()).then((value) => {
        self[fieldName](value);
      });
    });
  }
}
